import { useMemo } from 'react'
import { useDebounce } from '../../../../shared/hooks/useDebounce'
import { useControllingQuery } from '../../../../entities/controlling'
import {
  mapFiltersFormToApi,
  ControllingFiltersForm,
} from './controllingFilters.types'
import {
  toControllingFiltersForm,
  useControllingFiltersParams,
} from './useControllingFiltersParams'

const PAGE_LIMIT = 7;

export function useControllingFilters() {
  const [params, setParams] = useControllingFiltersParams()

  const filters = useMemo<ControllingFiltersForm>(
    () => toControllingFiltersForm(params),
    [params],
  )

  const debouncedFilters = useDebounce(filters, 400)

  const apiFilters = useMemo(
    () => ({ ...mapFiltersFormToApi(debouncedFilters, PAGE_LIMIT), page: params.page }),
    [debouncedFilters, params.page],
  )

  const query = useControllingQuery(apiFilters)

  return {
    filters,
    setFilters: setParams,
    page: params.page,
    setPage: (p: number) => setParams({ page: p }),
    ...query,
  }
}
